import { Component, Inject, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { UsersService } from '@app/services/users.service';

@Component({
  selector: 'app-cambiar-tecnico-dialog',
  standalone: true,
  imports: [
    CommonModule, FormsModule, ReactiveFormsModule, MatDialogModule,
    MatFormFieldModule, MatInputModule, MatAutocompleteModule,
    MatButtonModule, MatIconModule
  ],
  templateUrl: './cambiar-tecnico-dialog.component.html',
  styleUrls: ['./cambiar-tecnico-dialog.component.scss']
})
export class CambiarTecnicoDialogComponent implements OnInit {
  @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger;

  tecnicoControl = new FormControl<any>(null, Validators.required);
  private tecnicosSource = new BehaviorSubject<any[]>([]);
  filteredTecnicos$!: Observable<any[]>;

  constructor(
    public dialogRef: MatDialogRef<CambiarTecnicoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) 
    public data: { solicitudId: number, tecnicoActual: any, clienteNombre: any, localNombre: any },
    private usersService: UsersService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // 1. Lógica de filtrado reactivo
    this.filteredTecnicos$ = combineLatest([
      this.tecnicosSource.asObservable(),
      this.tecnicoControl.valueChanges.pipe(startWith(''))
    ]).pipe(
      map(([tecnicos, value]:any) => {
        const filterValue = (typeof value === 'string' ? value : value?.name || '').toLowerCase();
        if (!filterValue) return tecnicos;

        return tecnicos.filter((t:any) => 
          t.name?.toLowerCase().includes(filterValue) || 
          t.lastName?.toLowerCase().includes(filterValue) ||
          t.rut?.toLowerCase().includes(filterValue)
        );
      })
    );

    // 2. Carga masiva de técnicos (Top 500)
    this.usersService.getAllTecnicos(1, 500).subscribe({
      next: (response: any) => {
        const arrayTecnicos = response.data || response; 
        // Solo excluimos al que ya está asignado para evitar re-asignaciones idénticas
        const lista = arrayTecnicos.filter((u: any) => u.id !== this.data.tecnicoActual?.id);
        
        this.tecnicosSource.next(lista);
        this.cd.detectChanges();
      },
      error: (err:any) => console.error('Error al cargar lista de técnicos:', err)
    });
  }

  displayFn = (tecnico: any): string => tecnico ? `${tecnico.name} ${tecnico.lastName}` : '';

  openPanel = () => this.autocomplete?.openPanel();

  confirmar(): void {
    const seleccion = this.tecnicoControl.value;
    if (seleccion?.id) {
      this.dialogRef.close({ tecnicoId: seleccion.id });
    }
  }
}